import React, { useState, useCallback } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaStore } from "react-icons/fa";
import Navbar from "../components/Navbar";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const storeLocations = [
  {
    name: "Lahore Store",
    position: { lat: 31.582045, lng: 74.329376 },
    address: "Mall Road, Lahore, Pakistan",
  },
  {
    name: "Karachi Store",
    position: { lat: 24.860735, lng: 67.001137 },
    address: "Clifton, Karachi, Pakistan",
  },
  {
    name: "Islamabad Store",
    position: { lat: 33.684422, lng: 73.047882 },
    address: "Blue Area, Islamabad, Pakistan",
  },
  {
    name: "Rahim Yar Khan Store",
    position: { lat: 28.4202, lng: 70.2989 },
    address: "Model Town, Rahim Yar Khan, Pakistan",
  },
];

const StoreLocator = () => {
  const [selectedStore, setSelectedStore] = useState(storeLocations[0]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyC16o7T0EWX0eCl0iEc6fZOq-yld5oPG7Q", // 🔑 replace with your key
  });

  const onLoad = useCallback((map) => {
    map.setCenter(selectedStore.position);
    map.setZoom(6);
  }, [selectedStore]);

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 p-6 sm:p-8">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 mb-10 mt-16">
          Store Locator 🏬
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
          {/* Left Side – Store List */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white/80 backdrop-blur-lg border border-purple-100 shadow-xl rounded-3xl p-6 overflow-y-auto"
          >
            <h2 className="text-xl font-bold text-purple-700 mb-4 flex items-center gap-2">
              <FaStore /> Our Stores in Pakistan
            </h2>

            <div className="space-y-4">
              {storeLocations.map((store, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.03 }}
                  onClick={() => setSelectedStore(store)}
                  className={`cursor-pointer rounded-2xl p-4 transition border ${
                    selectedStore.name === store.name
                      ? "border-purple-500 bg-gradient-to-r from-purple-100 to-pink-100"
                      : "border-gray-200 bg-white hover:shadow-md"
                  }`}
                >
                  <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                    <FaMapMarkerAlt className="text-purple-600" /> {store.name}
                  </h3>
                  <p className="text-gray-600 text-sm mt-1">{store.address}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right Side – Google Map */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="w-full h-[400px] sm:h-[500px] lg:h-[600px] bg-white rounded-3xl overflow-hidden shadow-lg"
          >
            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={selectedStore.position}
                zoom={6}
                onLoad={onLoad}
                options={{
                  styles: [
                    {
                      featureType: "all",
                      elementType: "labels.text.fill",
                      stylers: [{ color: "#6b21a8" }],
                    },
                    {
                      featureType: "poi",
                      stylers: [{ visibility: "off" }],
                    },
                  ],
                }}
              >
                {storeLocations.map((store, index) => (
                  <Marker
                    key={index}
                    position={store.position}
                    icon={{
                      url: "https://maps.google.com/mapfiles/ms/icons/purple-dot.png",
                    }}
                  />
                ))}
              </GoogleMap>
            ) : (
              <div className="flex justify-center items-center h-full text-gray-500">
                Loading map...
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default StoreLocator;
